// @flow

import type { FormErrors } from '@globalTypes';

import {
  WORK_EXPERIENCES_REQUEST,
  WORK_EXPERIENCES_REQUESTED,
  WORK_EXPERIENCES_REQUESTED_ERROR,
  WORK_EXPERIENCE_CREATE,
  WORK_EXPERIENCE_CREATED,
  WORK_EXPERIENCE_CREATED_ERROR,
  WORK_EXPERIENCE_RESET,
  WORK_EXPERIENCE_DELETE,
  WORK_EXPERIENCE_DELETED,
  WORK_EXPERIENCE_DELETED_ERROR,
  WORK_EXPERIENCE_UPDATE,
  WORK_EXPERIENCE_UPDATED,
  WORK_EXPERIENCE_UPDATED_ERROR
} from './constants';

import type {
  ResetAction,
  GetAction,
  CreateAction,
  UpdateAction,
  DeleteAction,
  WorkExperience,
  WorkExperiences
} from '../types';

export const requestWorkExperiences = (): GetAction => ({
  type: WORK_EXPERIENCES_REQUEST
});

export const updateWorkExperiences = (data: WorkExperiences): GetAction => ({
  type: WORK_EXPERIENCES_REQUESTED,
  data
});

export const errorWorkExperiences = (error: Error): GetAction => ({
  type: WORK_EXPERIENCES_REQUESTED_ERROR,
  error
});

export const createWorkExperience = (data: WorkExperience): CreateAction => ({
  type: WORK_EXPERIENCE_CREATE,
  data
});

export const createdWorkExperience = (): CreateAction => ({
  type: WORK_EXPERIENCE_CREATED
});

export const errorCreateWorkExperience = (error: FormErrors): CreateAction => ({
  type: WORK_EXPERIENCE_CREATED_ERROR,
  error
});

export const updateWorkExperience = (id: string, data: WorkExperience): UpdateAction => ({
  type: WORK_EXPERIENCE_UPDATE,
  data,
  id
});

export const updatedWorkExperience = (id: string): UpdateAction => ({
  type: WORK_EXPERIENCE_UPDATED,
  id
});

export const errorUpdateWorkExperience = (id: string, error: FormErrors): UpdateAction => ({
  type: WORK_EXPERIENCE_UPDATED_ERROR,
  error,
  id
});

export const deleteWorkExperience = (id: string): DeleteAction => ({
  type: WORK_EXPERIENCE_DELETE,
  id
});

export const deletedWorkExperience = (id: string): DeleteAction => ({
  type: WORK_EXPERIENCE_DELETED,
  id
});

export const errorDeletedWorkExperience = (id: string, error: Error): DeleteAction => ({
  type: WORK_EXPERIENCE_DELETED_ERROR,
  error,
  id
});

export const resetWorkExperience = (): ResetAction => ({ type: WORK_EXPERIENCE_RESET });
